module.exports = __webpack_public_path__ + "static/img/img2.eb8ba74b.jpg";